import Vue from 'vue';

var PortalTarget = Vue.extend({
  abstract: true,
  name: 'PortalTarget',
  props: ['nodes'],
  data: vm => ({
    updatedNodes: vm.nodes
  }),
  destroyed() {
    const {
      $el: el
    } = this;
    el.parentNode.removeChild(el);
  },
  render(createElement) {
    const nodes = this.updatedNodes && this.updatedNodes();
    if (!nodes) {
      return createElement();
    }
    if (nodes.length < 2 && !nodes[0].text) {
      return nodes;
    }
    return createElement('div', nodes);
  }
});

export { PortalTarget as default };
//# sourceMappingURL=portal-target.js.map
